import FakeCheckbox from '@repo/ui/components/fake-checkbox'
import FakeRadio from '@repo/ui/components/fake-radio'
import { cn } from '@repo/ui/lib/utils'
import Link from 'next/link'
import { FunctionComponent } from 'react'
import { colorFilterProperty } from '../../../services/refinement.service'
import { FilterOption, FilterProperty } from '../../../types/collection.types'

interface Option extends Partial<FilterOption> {
  key: string
  isActive: boolean
  label: string
  href: string
}

interface Props {
  title: string
  type: 'radio' | 'checkbox'
  options: Option[]
  property?: FilterProperty
}

const CollectionFilterOption: FunctionComponent<Props> = ({ title, type, options, property }) => {
  const FormType = type === 'radio' ? FakeRadio : FakeCheckbox
  const renderSwatches = property?.id === colorFilterProperty.id

  if (options.length === 0) {
    return null
  }

  return (
    <li className='p-3'>
      <h3 className='mb-4 uppercase'>{title}</h3>
      <ol className='space-y-2' role='list'>
        {options.map((option) => {
          return (
            <li key={option.key}>
              <Link
                href={option.href}
                aria-current={option.isActive ? 'page' : undefined}
                className={cn(
                  'focus-visible:outline-hidden focus-visible:ring-ring group flex items-center gap-2 rounded-sm no-underline focus-visible:ring-1 focus-visible:ring-offset-2',
                  option.isActive && 'font-semibold',
                )}
              >
                <FormType
                  className={cn(renderSwatches && 'rounded-full')}
                  background={renderSwatches ? String(option?.color) : undefined}
                  checked={option.isActive}
                  aria-hidden='true'
                />
                {option.label}
              </Link>
            </li>
          )
        })}
      </ol>
    </li>
  )
}

export default CollectionFilterOption
